module.exports = __webpack_public_path__ + "static/img/macOS_FAQ_pic08.f588dce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/macOS_FAQ/macOS_FAQ_pic08.png
// module id = 508
// module chunks = 1